/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2023
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
export default async function sendWorkerData(data) {
  //inline
  let workerUrl = new URL('apiconnect-example-generator/worker', import.meta.url);
  let generatorWorker = new Worker(workerUrl);
  return new Promise(function (resolve, reject) {
    generatorWorker.onmessage = function (event) {
      if (event.data != null && event.data.error) {
        reject(event.data.error);
      } else if (event.data != null) {
        resolve(event.data);
      }
      generatorWorker.terminate();
    };

    generatorWorker.onerror = function (error) {
      reject(error);
      generatorWorker.terminate();
    };

    generatorWorker.postMessage(data);
  });
}
